import { Switch } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ShowOnOffIcons from './ShowOnOffIcons';
import { ShowUnlicensedToggle } from '../LearningCollections/LearningCollection/CurrentCollectionStep/Builder/ExperienceCatalog/Types';
import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { emptyFragment } from '../../EmptyFragment';

interface Props {
  value: boolean;
  cursorClassName?: string;
  handleOnClick: () => void;
  iconClassName?: string;
  onOffIcon?: ShowUnlicensedToggle;
  intercomTarget?: string;
  ariaLabel?: string;
}

const ToggleButton: React.FC<Props> = ({
  value,
  handleOnClick,
  iconClassName,
  cursorClassName = 'cursor-pointer',
  onOffIcon = 'hide',
  intercomTarget = 'Toggle button',
  ariaLabel,
}) => {
  return (
    <Switch
      checked={value}
      onChange={handleOnClick}
      data-intercom-target={intercomTarget}
      aria-label={ariaLabel}
      className={clsx(
        value ? 'bg-teal-600' : 'bg-gray-200',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer',
        'rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out',
        cursorClassName,
      )}
    >
      <span
        aria-hidden="true"
        className={clsx(
          value ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow',
          'ring-0 transition duration-200 ease-in-out flex align-center',
          iconClassName,
        )}
      >
        {when(equals(onOffIcon, 'show'), {})
          .map(() => <ShowOnOffIcons value={value} />)
          .getOrElse(emptyFragment)}
      </span>
    </Switch>
  );
};

export default observer(ToggleButton);
